"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SegmentedButton", {
    enumerable: true,
    get: function() {
        return SegmentedButton;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var buttonActiveStyles = {
    primary: {
        backgroundColor: "primary-default",
        color: "text-light",
        boxShadow: "0 0 0 1px var(--chakra-colors-primary-default)",
        _hover: {
            backgroundColor: "primary-default",
            color: "text-light"
        },
        _active: {
            backgroundColor: "primary-default"
        },
        _disabled: {
            color: "text-light",
            backgroundColor: "primary-disabled",
            boxShadow: "0 0 0 1px var(--chakra-colors-primary-disabled)"
        },
        _focus: {
            outline: "3px solid var(--chakra-colors-primary-focus)"
        }
    },
    "primary-alt": {
        backgroundColor: "background-action-pressed",
        color: "text-link-primary-default",
        boxShadow: "0 0 0 1px var(--chakra-colors-primary-default)",
        _hover: {
            backgroundColor: "background-action-pressed"
        },
        _active: {
            backgroundColor: "background-action-pressed"
        },
        _disabled: {
            color: "text-link-primary-disabled",
            backgroundColor: "background-action-disabled",
            boxShadow: "0 0 0 1px var(--chakra-colors-text-link-primary-disabled)"
        },
        _focusVisible: {
            outline: "3px solid var(--chakra-colors-primary-focus)",
            outlineOffset: "1px"
        },
        _focus: {
            outline: "3px solid var(--chakra-colors-primary-focus)",
            outlineOffset: "1px"
        }
    },
    secondary: {
        backgroundColor: "secondary-default",
        color: "text-light",
        boxShadow: "0 0 0 1px var(--chakra-colors-secondary-default)",
        _hover: {
            backgroundColor: "secondary-default"
        },
        _active: {
            backgroundColor: "secondary-default"
        },
        _disabled: {
            color: "text-light",
            backgroundColor: "secondary-disabled",
            boxShadow: "0 0 0 1px var(--chakra-colors-secondary-disabled)"
        },
        _focus: {
            outline: "3px solid var(--chakra-colors-secondary-focus)"
        }
    },
    "secondary-alt": {
        backgroundColor: "background-action-pressed",
        color: "text-link-secondary-default",
        boxShadow: "0 0 0 1px var(--chakra-colors-secondary-default)",
        _hover: {
            backgroundColor: "background-action-pressed"
        },
        _active: {
            backgroundColor: "background-action-pressed"
        },
        _disabled: {
            color: "text-link-secondary-disabled",
            backgroundColor: "background-action-disabled",
            boxShadow: "0 0 0 1px var(--chakra-colors-text-link-secondary-disabled)"
        },
        _focusVisible: {
            outline: "3px solid var(--chakra-colors-secondary-focus)",
            outlineOffset: "1px"
        },
        _focus: {
            outline: "3px solid var(--chakra-colors-secondary-focus)",
            outlineOffset: "1px"
        }
    }
};
var buttonStyles = {
    primary: {
        backgroundColor: "background-action-default",
        color: "text-secondary",
        _hover: {
            backgroundColor: "background-action-hover",
            color: "text-secondary"
        },
        _active: {
            backgroundColor: "background-action-default"
        },
        _disabled: {
            color: "text-disabled",
            backgroundColor: "background-action-disabled"
        },
        _focus: {
            outline: "3px solid var(--chakra-colors-primary-focus)"
        }
    },
    "primary-alt": {
        backgroundColor: "background-action-default",
        color: "text-secondary",
        _hover: {
            backgroundColor: "background-action-hover",
            color: "text-secondary"
        },
        _active: {
            backgroundColor: "background-action-default"
        },
        _disabled: {
            color: "text-disabled",
            backgroundColor: "background-action-disabled"
        },
        _focusVisible: {
            outline: "3px solid var(--chakra-colors-primary-focus)"
        },
        _focus: {
            outline: "3px solid var(--chakra-colors-primary-focus)"
        }
    },
    secondary: {
        backgroundColor: "background-action-default",
        color: "text-secondary",
        _hover: {
            backgroundColor: "background-action-hover",
            color: "text-secondary"
        },
        _active: {
            backgroundColor: "background-action-default"
        },
        _disabled: {
            color: "text-disabled",
            backgroundColor: "background-action-disabled"
        },
        _focus: {
            outline: "3px solid var(--chakra-colors-secondary-focus)"
        }
    },
    "secondary-alt": {
        backgroundColor: "background-action-default",
        color: "text-secondary",
        _hover: {
            backgroundColor: "background-action-hover",
            color: "text-secondary"
        },
        _active: {
            backgroundColor: "background-action-default"
        },
        _disabled: {
            color: "text-disabled",
            backgroundColor: "background-action-disabled"
        },
        _focusVisible: {
            outline: "3px solid var(--chakra-colors-secondary-focus)"
        },
        _focus: {
            outline: "3px solid var(--chakra-colors-secondary-focus)"
        }
    }
};
var SegmentedButton = {
    parts: [
        "container",
        "button",
        "icon"
    ],
    baseStyle: function(param) {
        var theme = param.theme;
        return {
            container: {
                gap: "1px",
                bg: "ui-element-outline-default",
                display: "inline-flex",
                borderStyle: "solid",
                borderWidth: "1px",
                borderColor: "ui-element-outline-default",
                borderRadius: "radii-button"
            },
            button: {
                borderRadius: "unset",
                gap: "spacer-2",
                outlineOffset: "unset",
                _first: {
                    borderTopLeftRadius: "calc(".concat(theme.radii["radii-button"], " - 0.0625rem)"),
                    borderBottomLeftRadius: "calc(".concat(theme.radii["radii-button"], " - 0.0625rem)")
                },
                _last: {
                    borderTopRightRadius: "calc(".concat(theme.radii["radii-button"], " - 0.0625rem)"),
                    borderBottomRightRadius: "calc(".concat(theme.radii["radii-button"], " - 0.0625rem)")
                },
                _focus: {
                    zIndex: "1"
                }
            }
        };
    },
    sizes: {
        xs: function(param) {
            var theme = param.theme;
            return {
                button: _object_spread({
                    px: "8px",
                    py: "4px"
                }, theme.textStyles["text-body-floating-label-medium"]),
                icon: {
                    px: "6px",
                    py: "6px"
                }
            };
        },
        s: function(param) {
            var theme = param.theme;
            return {
                button: _object_spread({
                    px: "12px",
                    py: "8px"
                }, theme.textStyles["text-body-meta-medium"]),
                icon: {
                    px: "10px",
                    py: "10px"
                }
            };
        },
        m: function(param) {
            var theme = param.theme;
            return {
                button: _object_spread({
                    px: "12px",
                    py: "8px"
                }, theme.textStyles["text-body-medium"]),
                icon: {
                    px: "10px",
                    py: "10px"
                }
            };
        },
        l: function(param) {
            var theme = param.theme;
            return {
                button: _object_spread({
                    px: "24px",
                    py: "12px"
                }, theme.textStyles["text-body-large-medium"]),
                icon: {
                    px: "14px",
                    py: "14px"
                }
            };
        }
    },
    variants: {
        primary: function(param) {
            var isActive = param.isActive;
            return {
                button: isActive ? buttonActiveStyles.primary : buttonStyles.primary
            };
        },
        "primary-alt": function(param) {
            var isActive = param.isActive;
            return {
                button: isActive ? buttonActiveStyles["primary-alt"] : buttonStyles["primary-alt"]
            };
        },
        secondary: function(param) {
            var isActive = param.isActive;
            return {
                button: isActive ? buttonActiveStyles.secondary : buttonStyles.secondary
            };
        },
        "secondary-alt": function(param) {
            var isActive = param.isActive;
            return {
                button: isActive ? buttonActiveStyles["secondary-alt"] : buttonStyles["secondary-alt"]
            };
        }
    },
    defaultProps: {
        variant: "primary"
    }
};
